const _ = require('lodash');

function ProductGroupCarouselService() {
    this.productGroupCarouselsCache = [];
}

ProductGroupCarouselService.prototype.cacheProductGroupCarousel = function (productGroupCarousel) {
    return this.productGroupCarouselsCache.push(productGroupCarousel);
};

ProductGroupCarouselService.prototype.getCachedCarousel = function (productGroupId) {
    return _.find(this.productGroupCarouselsCache, function (item) {
        if (item.productGroupId === productGroupId) {
            return item;
        }
    });
};

ProductGroupCarouselService.prototype.isProductGroupCarouselCached = function (productGroupId) {
    return _.find(this.productGroupCarouselsCache, function (item) {
        return item.productGroupId === productGroupId;
    });
};

ProductGroupCarouselService.prototype.invalidate = function () {
    this.productGroupCarouselsCache.length = 0;
};

module.exports = ProductGroupCarouselService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroups/product-group-carousel-service.js
 **/